Controller = App.loadClass 'core::Angular/Controller'

class exports.StepsController extends Controller
    constructor: (@scope, @transitions, @service, @state, @modal, @http, @ngModal) ->
        super

        @scope.fullpage = true
        @scope.service = @service
        @scope.isUploadedPBIConnected = false

        @service.loadConfig().then () =>
            if _.isEmpty(@service.fpcResult) and @state.params.id and @state.params.step
                @service.loadFieldprint(@state.params.id).then () =>
                    @service.gotoStep @state.params.step - 1, @state.params.id, false

        @scope.$watch 'service.fpcResult.data', (n, o) =>
            @service.calculateCompleteness()
        , true

        @scope.$watch 'service.showIncompletenessMessage', (show, o) =>
            if show
                @showValidationErrorMessage()
            else
                @writer.hide()
        , true

        @scope.$watch 'service.changeStepFromSidebar', (n, o) =>
            if @service.showIncompletenessMessage
                @writer.hide()
                @showValidationErrorMessage()

        , true

        @writer = $('.absolute-errorDiv').message_writer autoHide: false
        @loadUploadedPBIConnection()

    gotoPrevStep: () =>
        @service.gotoStep(@service.currentStepIndex - 1)

    gotoNextStep: () =>
        @service.gotoStep(@service.currentStepIndex + 1)

    saveFieldprint: (triggerMissing) =>
        @service.save(@service.state.params.id)

        if triggerMissing
            if @service.triggerMissing @service.currentStepIndex + 1
                @service.showIncompletenessMessage = true
                @service.changeStepFromSidebar = false
                return

        if not @service.hasOtherPractices
            @openOtherPractices()
            return

        if not @service.isFieldLinkedExternally and @service.hasPBIConnection and @scope.isUploadedPBIConnected and not @service.isFieldLinkedUploadedPbi
            @http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', @service.fpcResult.events['planting']).then (response) =>
                if response.data
                    @openPBIConnections().then  () =>
                        @openUploadedPBIConnections().then () =>
                            @exitFieldprint()
                        , () =>
                            @exitFieldprint()
                else
                    @exitFieldprint()
        else if not @service.isFieldLinkedExternally and @service.hasPBIConnection
            @http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', @service.fpcResult.events['planting']).then (response) =>
                if response.data
                    @openPBIConnections().then () =>
                        @exitFieldprint()
                    , () =>
                        @exitFieldprint()
                else
                    @exitFieldprint()

        else if @scope.isUploadedPBIConnected and not @service.isFieldLinkedUploadedPbi
            @http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', @service.fpcResult.events['planting']).then (response) =>
                if response.data
                    @openUploadedPBIConnections().then  () =>
                        @exitFieldprint()
                    , () =>
                        @exitFieldprint()
                else
                    @exitFieldprint()
        else
            @exitFieldprint()

    isOnFirstStep: () =>
        @service.currentStepIndex is 0

    isOnLastStep: () =>
        return false if not @service.config?[@service.crop]?.steps?
        @service.currentStepIndex is Object.keys(@service.config[@service.crop].steps.value).length - 1

    # Checks for uploaded pbi fields
    loadUploadedPBIConnection: () =>
        @service.hasPBIUploadedConnection(@service.year).then (response) =>
            @scope.isUploadedPBIConnected = response.data

    openOtherPractices: () =>
        dialogClosed = () =>
            if not @service.isFieldLinkedExternally and @service.hasPBIConnection and @scope.isUploadedPBIConnected and not @service.isFieldLinkedUploadedPbi
                @openPBIConnections().then () =>
                    @openUploadedPBIConnections().then () =>
                        @exitFieldprint()
                    , () =>
                        @exitFieldprint()
            else if not @service.isFieldLinkedExternally and @service.hasPBIConnection
                @openPBIConnections().then () =>
                    @exitFieldprint()
                , () =>
                    @exitFieldprint()
            else if @scope.isUploadedPBIConnected and not @service.isFieldLinkedUploadedPbi
                @openUploadedPBIConnections().then () =>
                    @exitFieldprint()
                , () =>
                    @exitFieldprint()
            else
                @exitFieldprint()

        if @service.hasSaifsaOtherPractices
            @ngModal.launchFsaOtherPractices(@service.year, @service.crop).then((result) =>
                result.modalRef.result.then(() =>
                    dialogClosed()
                , () =>
                    dialogClosed()
                )
            )
        else
            @http.post 'backend/grower/other-practices/load',
                year: @service.year
                crop: @service.crop
            .then (response) =>
                @modal.open
                    windowClass: 'medium_dialog'
                    controller: 'Fieldprint.Controllers.OtherPracticesController'
                    templateUrl: 'backend/grower/fieldprint/other-practices-dialog'
                    scope: @scope.$new()
                    resolve:
                        selections: () => {
                            year: @service.year
                            crop: @service.crop
                        }
                        survey: () => response.data
                .result.then () =>
                    dialogClosed()

    openPBIConnections: () =>
        return @ngModal.openPBIConnectionsDialog('edit', @service.year, @service.fpcResult.field, true).modalRef.result

    openUploadedPBIConnections: () =>
        return @ngModal.openUploadedPBIConnectionsDialog('edit', @service.year, @service.fpcResult.field, true).modalRef.result

    showValidationErrorMessage: () =>
        if @service.changeStepFromSidebar
            verb = 'try again'
        else if @isOnLastStep()
            verb = 'click "Save + Close"'
        else
            verb = 'click "Next"'

        @writer.message_writer 'error', "Some required information is missing. Please complete the areas highlighted orange and #{ verb }."

    exitFieldprint: () =>
        # Reset things for the sidebar so it isn't set when it loads
        @service.field = null
        @state.go 'grower.fieldprint', {}, reload: 'grower.fieldprint'
